/* istanbul ignore file */
// For help adding new icons, or editing existing icons, see the readme file inside the icon component folder

export enum IconSource {
  add = "add",
  addInvertedRound = "addInvertedRound",
  angleUp = "angleUp",
  announcement = "announcement",
  block = "block",
  calendar = "calendar",
  catalogue = "catalogue",
  delete = "delete",
  description = "description",
  detachedOccurrence = "detachedOccurrence",
  down = "down",
  dropdown = "dropdown",
  edit = "edit",
  email = "email",
  error = "error",
  exit = "exit",
  expired = "expired",
  export = "export",
  favourite = "favourite",
  featured = "featured",
  general = "general",
  guest = "guest",
  help = "help",
  hide = "hide",
  home = "home",
  image = "image",
  info = "info",
  leftArrow = "leftArrow",
  leftChevron = "leftChevron",
  loading = "loading",
  location = "location",
  lock = "lock",
  logout = "logout",
  meal = "meal",
  menu = "menu",
  metrics = "metrics",
  more = "more",
  noSearchResults = "noSearchResults",
  notification = "notification",
  paid = "paid",
  password = "password",
  phone = "phone",
  published = "published",
  recent = "recent",
  replace = "replace",
  residents = "residents",
  rightArrow = "rightArrow",
  rightChevron = "rightChevron",
  rotate = "rotate",
  search = "search",
  send = "send",
  series = "series",
  show = "show",
  specialDay = "specialDay",
  status = "status",
  success = "success",
  successTick = "successTick",
  toggleBoth = "toggleBoth",
  toggleDown = "toggleDown",
  toggleUp = "toggleUp",
  undo = "undo",
  up = "up",
  updates = "updates",
  village = "village",
  virtual = "virtual",
  zoomIn = "zoomIn",
  zoomOut = "zoomOut",
  dollarTag = "dollarTag"
}
